import React, { createContext, useContext, useMemo } from 'react';

import { SharedComponentModel } from '../Models/SharedComponentModel';
import { ViewModel } from '../Models/ViewModel';

interface IDesignerViewContext {
	view: ViewModel | null;
	sharedComponent: SharedComponentModel | null;
}

const emptyDesignerViewContext: IDesignerViewContext = {
	view: null,
	sharedComponent: null,
};

export const DesignerViewContext = createContext<IDesignerViewContext>(emptyDesignerViewContext);

export function useDesignerView() {
	return useContext(DesignerViewContext);
}

type DesignerViewProviderProps = {
	view?: ViewModel | null;
	sharedComponent?: SharedComponentModel | null;
	children: React.ReactNode;
};

export default function DesignerViewProvider({ view, sharedComponent, children }: DesignerViewProviderProps) {
	const value = useMemo<IDesignerViewContext>(
		() => ({
			view: view ?? null,
			sharedComponent: sharedComponent ?? null,
		}),
		[view, sharedComponent],
	);

	return <DesignerViewContext.Provider value={value}>{children}</DesignerViewContext.Provider>;
}
